import { isLoggedInAtom, presentLoginSheet } from 'app/atoms';
import { GuestSignupPrompt } from 'app/components/authentication/GuestSignupPrompt';
import { LoginSheet } from 'app/screens/onboarding/login';
import { useAtom, useAtomValue } from 'jotai';
import { Platform } from 'react-native';
import { useEffect, useRef } from 'react';
import { navigationRef } from 'app/lib/root-navigation';
import { getGuestLoginLandingState } from 'app/lib/navigation/guest-login-landing';

export function GuestWebLoginHost() {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const loginSheetState = useAtom(presentLoginSheet);
  const wasLoggedIn = useRef(isLoggedIn);
  useEffect(() => {
    const justLoggedIn = !wasLoggedIn.current && isLoggedIn;
    wasLoggedIn.current = isLoggedIn;
    if (!justLoggedIn || Platform.OS !== 'web' || !navigationRef.isReady()) return;
    const rootState = navigationRef.getRootState();
    const nextState = rootState && getGuestLoginLandingState(rootState);
    if (nextState) navigationRef.resetRoot(nextState);
  }, [isLoggedIn]);
  if (Platform.OS !== 'web' || isLoggedIn) return null;
  return (
    <>
      <GuestSignupPrompt />
      <LoginSheet state={loginSheetState} />
    </>
  );
}
